// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-ye5","item":"CiZG_"};